
import { Component, Vue, Watch } from 'vue-property-decorator';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { namespace } from 'vuex-class';
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
import { Moment } from 'moment';
const Hundun = namespace('Hundun');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import client from 'baimahu/client';

const API = {
  change_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  get_list: `${FCAPI}/boss/hundun/work/visit`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  more_change: `${FCAPI}/boss/hundun/user/batch/0`,
  mark: `${FCAPI}/boss/hundun/work/visit/mark/1`,
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`
};
interface from {
  charge_teacher_id: number[];
  back_status: [];
  follow_status: number;
  branch_id: number;
  mobile: string;
  visit_time: Moment[];
}
function initForm() {
  return {
    charge_teacher_id: [],
    follow_status: '0',
    back_status: [],
    branch_id: 0,
    mobile: '',
    visit_time: []
  };
}
@Component
export default class BackList extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; // 线上学籍选项
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  /* eslint-enable */
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  get tag_without_all() {
    let s = [...this.tag_list];
    s.pop();
    return s;
  }
  get teacher_width_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }
  get follow_status_without_all() {
    let s = [...this.follow_status];
    s.pop();
    return s.slice(1);
  }
  locale = zhCN;
  user: any = {};
  form = initForm();
  tag_value = []; //新增标签value
  show_add_tag = false;
  show_change_modal = false; //批量修改弹框
  is_loading = false;
  show_confirm_modal = false; //确认已处理弹框
  more = false;
  content = '';
  is_select_all = false;
  tag_type = 1;
  back_status = [
    {
      id: 0,
      value: '全部'
    },
    {
      id: 1,
      value: '一月后过期'
    },
    {
      id: 6,
      value: '一周后过期'
    },
    {
      id: 7,
      value: '三天后过期'
    },
    {
      id: 2,
      value: '三月后过期'
    },
    {
      id: 3,
      value: '过期续费'
    },
    {
      id: 4,
      value: '在籍续费'
    },
    {
      id: 5,
      value: '回访'
    },
    {
      id: 8,
      value: '学习提醒1月'
    },
    {
      id: 9,
      value: '学习提醒2月'
    },
    {
      id: 10,
      value: '学习提醒3月'
    },
    {
      id: 11,
      value: '学习提醒半年'
    }
  ];
  table_data: any = {
    //表格数据
  };
  log: string[] = []; //班主任备注
  select_row_key: any = []; //被选中项
  is_show_waring_select_all = false;
  window = window as any;
  user_list_id = '';
  props = { multiple: true };
  options = [
    {
      value: '过期提醒',
      label: '过期提醒',
      children: [
        { value: 1, label: '1月后过期' },
        { value: 6, label: '1周后过期' },
        { value: 7, label: '3天后过期' },
        { value: 2, label: '3月后过期' }
      ]
    },
    { value: 3, label: '过期续费' },
    { value: 4, label: '在籍续费' },
    { value: 5, label: '回访' },
    {
      value: '学习提醒',
      label: '学习提醒',
      children: [
        { value: 11, label: '学习提醒半年' },
        { value: 10, label: '学习提醒3月' },
        { value: 9, label: '学习提醒2月' },
        { value: 8, label: '学习提醒1月' }
      ]
    },
    {
      value: '入学时间',
      label: '入学时间',
      children: [
        { value: 12, label: '入学15天' },
        { value: 13, label: '入学30天' },
        { value: 14, label: '入学2个月' },
        { value: 15, label: '入学3个月' },
        { value: 16, label: '入学4个月' },
        { value: 17, label: '入学6个月' },
        { value: 18, label: '入学9个月' }
      ]
    }
  ];
  selectAll() {
    if (this.is_select_all) {
      this.is_show_waring_select_all = true;
    } else {
      this.select_row_key = [];
    }
  }
  confirmSelectAll() {
    this.select_row_key = this.table_data.detail.map((item: any) => item.id);
    this.is_show_waring_select_all = false;
  }
  @Watch('table_data', { deep: true })
  changeCurrnet() {
    if (this.is_select_all) {
      this.select_row_key = this.table_data.detail.map((item: any) => item.id);
    }
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d');
  }
  getCallbackType(item: any) {
    const time = new Date().getTime() - item.expired_time * 1000;
    const three_days = 3 * 24 * 3600;
    const one_week = 7 * 24 * 3600;
    const one_month = 30 * 24 * 3600;
    if (time <= three_days) {
      return '3天后过期';
    }
    if (time <= one_week) {
      return '1周后过期';
    }
    if (time <= one_month) {
      return '1月后过期';
    }
  }
  //已联系
  connect(record: any) {
    console.log(record);

    this.user = record;
    this.more = false;
    this.show_confirm_modal = true;
    this.content = '标记已联系后，该用户信息将在本列表内消失';
  }
  showConfirm() {
    this.show_change_modal = false;
    this.show_confirm_modal = true;
    this.content = '标记已联系后，批量勾选的用户信息将在本列表内消失';
  }
  //确认已联系
  async confirmConnection() {
    if (this.is_select_all) {
      const start_time = this.form.visit_time[0] ? Math.floor((this.form.visit_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const end_time = this.form.visit_time[1] ? Math.floor((this.form.visit_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
      const res = await this.$axios.put(API.mark, {
        charge_teacher_id: this.form.charge_teacher_id.toString(),
        follow_status: ~~this.form.follow_status,
        visit_type: this.form.back_status,
        work_type: 'visit',
        branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
        visit_time_start: start_time,
        visit_time_end: end_time,
        mobile: this.form.mobile ? this.form.mobile : ''
      });
      if (res.status === 200) {
        this.$message.success('操作成功');
        this.search(this.table_data.current);
        this.show_confirm_modal = false;
        return;
      }
    }
    if (!this.more) {
      const res: any = await this.$axios.put(`${API.get_list}/${this.user.id}`);
      if (res.status === 200) {
        this.$message.success('操作成功');
        this.search(this.table_data.current);
        this.show_confirm_modal = false;
      } else {
        this.$message.error('操作失败');
      }
    } else {
      // this.moreChange(this.select_row_key, 'markup_visit', 2);
      // this.show_confirm_modal = false;
      this.moreChange(this.select_row_key, 2);
      this.show_confirm_modal = false;
    }
  }
  async moreChange(id: any, value: any) {
    const send_data = {
      id: id,
      markup_visit: value
    };
    await this.$axios.put(`${API.more_change}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
  }
  //添加备注
  async addLog(id: any, index: number) {
    //修改班主任备注
    if (!this.log[index]) {
      return;
    }
    const send_data = {
      user_id: id,
      content: this.log[index]
    };
    const res: any = await this.$axios.post(`${API.change_log}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.search(this.table_data.current);
      this.log[index] = '';
    }
  }
  // 分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  // 切换分页
  changePage(page: any) {
    this.search(page.current);
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  //搜索
  async search(page = 1) {
    this.is_loading = true;
    const start_time = this.form.visit_time[0] ? Math.floor((this.form.visit_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const end_time = this.form.visit_time[1] ? Math.floor((this.form.visit_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    let back_status = '';
    console.log(this.form.back_status);
    if (this.form.back_status) {
      this.form.back_status.forEach((element: any) => {
        back_status += element[element.length - 1] + ',';
      });
    }
    const send_data = {
      charge_teacher_id: this.form.charge_teacher_id.length === 0 ? '' : this.form.charge_teacher_id.join(','),
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      // visit_type: this.form.back_status === 0 ? '' : this.form.back_status,
      visit_type: back_status,
      work_type: 'visit',
      branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
      visit_time_start: start_time,
      visit_time_end: end_time,
      mobile: this.form.mobile ? this.form.mobile : '',
      current: page,
      limit: 20
    };
    const url = getUrl(API.get_list, send_data);
    const res: any = await this.$axios.get(url);
    if (res.status === 200) {
      this.table_data = res.data.data ? res.data.data : [];
      this.is_loading = false;
      this.select_row_key = [];
    }
    this.select_row_key = [];
    this.is_select_all = false;
  }
  //删除标签
  async deleteTag(id: number) {
    this.is_loading = true;
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}?menu_id=${(window as any).route_menu_id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
      return;
    }
    this.is_loading = false;
  }
  //修改跟进状态
  async editDetail(column: string, value: any, record: any) {
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    const send_data = {
      column: column,
      value: value
    };
    await this.$axios.put(`${API.edit_user_detail}/${record.id}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
  }
  //添加标签
  addTag(record: any, type: number) {
    this.user = record;
    this.tag_value = [];
    this.show_add_tag = true;
    this.tag_type = type;
  }
  //确认添加标签
  confirmAddTag() {
    const value = this.tag_value.pop();
    this.editDetail('tag', value, this.user);
    this.show_add_tag = false;
  }
  clear() {
    this.is_select_all = false;
    this.form = initForm();
  }
  //批量修改
  showChangeModal() {
    if (this.select_row_key.length === 0) {
      this.$message.error('请先选择要修改的用户');
      return;
    }
    this.more = true;
    this.show_change_modal = true;
  }
  //查看用户详情
  check(record: any) {
    this.$router.push(`/hundun/user-detail/${record.id}?menu_id=${this.window.route_menu_id}`);
    console.log(record);
  }
  // menu_id更改
  async getMenuId() {
    const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
    this.user_list_id = data.menu_list[1].id;
  }
  created() {
    this.search(1);
    this.getMenuId();
  }
  onSelectChange(select_row_key: any) {
    //选择钩子函数
    console.log('select_row_key changed: ', select_row_key);
    this.select_row_key = select_row_key;
  }
}
